import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock, Wrench, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const serviceAreas = [
    'Mount Olive', 'Budd Lake', 'Hackettstown', 'Netcong', 'Flanders',
    'Chester', 'Randolph', 'Succasunna', 'Roxbury', 'Stanhope', 'Long Valley'
  ];

  // Company column content (removed for now, will be restored later):
  // - About, Gallery, FAQ, Financing Options links

  // Services column content (removed for now, will be restored later):
  // - Emergency Plumbing, Water Heater Repair, HVAC Installation, Drain Cleaning links

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-blue-900 text-white">
      {/* Main Footer Content */}
             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-12">
           {/* Left Container - Company Info */}
           <div className="space-y-6 lg:col-span-4">
             {/* <motion.div
               className="flex items-center space-x-3"
               whileHover={{ scale: 1.05 }}
             >
               <img 
                 src="/images/logo2.png" 
                 alt="Mount Olive Plumbing, Heating & Air Conditioning LLC" 
                 className="h-12 sm:h-16 w-auto"
               />
             </motion.div> */}


<div className="flex items-center space-x-3">
  <img
      src="/images/logo2.png"
    alt="Mount Olive Plumbing, Heating & Air Conditioning LLC"
    className="h-12 sm:h-16 w-auto"
  />
</div>
             
             <p className="text-gray-300 leading-relaxed text-sm sm:text-[15px]">
               Serving Morris County with reliable plumbing, heating, and air conditioning services for 20 years. Licensed, insured, and available 24/7 for emergencies.
             </p>


<div className="flex space-x-4 mt-6 sm:mt-8">
  {[
    {
      type: 'component',
      Icon: Facebook,
      href: 'https://www.facebook.com/p/Mount-Olive-Plumbing-100083106291508/'
    },
    {
      type: 'component',
      Icon: Instagram,
      href: 'https://www.instagram.com/moplumbing2018/'
    },
    {
      type: 'image',
      src: '/images/home_icon.png',
      alt: 'Home',
      href: 'https://nextdoor.com/pages/mount-olive-plumbing-heating-air-conditioning-llc-port-murray-nj/'
    },
    {
      type: 'image',
      src: '/images/BBB_icon.png',
      alt: 'Better Business Bureau',
      href: 'https://www.bbb.org/us/nj/budd-lake/profile/plumber/mount-olive-plumbing-heating-air-conditioning-llc-0221-90233049'
    },
  ].map((item, index) => (
    <motion.a
      key={index}
      href={item.href}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-gray-800/50 p-4 rounded-2xl hover:bg-gray-700/50 transition-all duration-300 backdrop-blur-sm flex items-center justify-center min-w-[56px] min-h-[56px]"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      {item.type === 'component' ? (
        <item.Icon
          className="h-10 w-10 transition-colors duration-300"
          style={{
            color: '#45C1FF',
            fill: index === 0 ? '#45C1FF' : 'none' // Fill only Facebook
          }}
        />
      ) : (
        <img
          src={item.src}
          alt={item.alt}
          // Scale up the last two icons to compensate for their internal padding
          className={`object-contain ${index >= 2 ? 'h-10 w-10' : 'h-10 w-10'}`}
        />
      )}
    </motion.a>
  ))}
</div>
           </div>

           {/* Company Links */}
           <div className="space-y-6 lg:col-span-2">
             <h4 className="text-sm sm:text-[15px] font-semibold text-white">Company</h4>
             <div className="space-y-3 sm:space-y-4">
               <motion.a
                 href="/about"
                 className="block text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
                 whileHover={{ x: 5 }}
               >
                 About
               </motion.a>
               <motion.a
                 href="/gallery"
                 className="block text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
                 whileHover={{ x: 5 }}
               >
                 Gallery
               </motion.a>
               <motion.a
                 href="/faq"
                 className="block text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
                 whileHover={{ x: 5 }}
               >
                 FAQ
               </motion.a>
               {/* <motion.a
                 href="/financing"
                 className="block text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
                 whileHover={{ x: 5 }}
               >
                 Financing Options
               </motion.a> */}
             </div>
           </div>

           {/* Services */}
           <div className="space-y-6 lg:col-span-2">
  <h4 className="text-sm sm:text-[15px] font-semibold text-white">Services</h4>
  <div className="space-y-3 sm:space-y-4">
    <motion.a
      href="/services#cta-section"
      className="block text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
      whileHover={{ x: 5 }}
    >
      Emergency Plumbing
    </motion.a>
    <motion.a
      href="/services#heating-services"
      className="block text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
      whileHover={{ x: 5 }}
    >
      Water Heater Repair
    </motion.a>
    <motion.a
      href="/services#ac-services"
      className="block text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
      whileHover={{ x: 5 }}
    >
      HVAC Installation
    </motion.a>
    <motion.a
      href="/services#plumbing-services"
      className="block text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
      whileHover={{ x: 5 }}
    >
      Drain Cleaning
    </motion.a>
  </div>
</div>

           {/* Contact Info */}
           <div className="space-y-6 lg:col-span-4">
             <h4 className="text-sm sm:text-[15px] font-semibold text-white">Contact Info</h4>
             <div className="space-y-3 sm:space-y-4">
               <motion.a
                 href="tel:+1-973-862-0606"
                 className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
                 whileHover={{ x: 5 }}
               >
                 <Phone className="h-4 w-4 sm:h-5 sm:w-5 text-blue-400 flex-shrink-0" />
                 <span className="break-all">(973) 862-0606</span>
               </motion.a>
               
               <motion.a
                 href="mailto:mountoliveplumbing@gmail.com"
                 className="flex items-start space-x-3 text-gray-300 hover:text-white transition-colors duration-300 text-sm sm:text-[15px]"
                 whileHover={{ x: 5 }}
               >
                 <Mail className="h-4 w-4 sm:h-5 sm:w-5 text-blue-400 mt-0.5 flex-shrink-0" />
                 <span className="break-all">mountoliveplumbing@gmail.com</span>
               </motion.a>
               
               <div className="flex items-start space-x-3 text-gray-300 text-sm sm:text-[15px]">
                 <MapPin className="h-4 w-4 sm:h-5 sm:w-5 text-blue-400 mt-0.5 flex-shrink-0" />
                 <span>Serving 20-mile radius around<br />Budd Lake, NJ 07828</span>
               </div>
               
               <div className="flex items-center space-x-3 text-gray-300 text-sm sm:text-[15px]">
                 <Clock className="h-4 w-4 sm:h-5 sm:w-5 text-blue-400 flex-shrink-0" />
                 <span>24/7 Emergency Service</span>
               </div>
             </div>
           </div>
         </div>

        {/* Large divider above Service Areas */}
        <div className="mt-12 h-px bg-gray-600"></div>

                 {/* Service Areas - Moved below main grid */}
         <div className="mt-8 sm:mt-12 space-y-4 sm:space-y-6">
           <h4 className="service-area-title text-center">
  SERVICE AREA
</h4>
           <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
             {serviceAreas.map((area, index) => (
               <div
                 key={index}
                 className="text-gray-300 px-2 sm:px-3 py-1 rounded-lg whitespace-nowrap text-xs sm:text-sm lg:text-[15px]"
               >
                 {area}
               </div>
             ))}
           </div>
         </div>

                 {/* Emergency CTA */}
         <motion.div
           className="mt-8 sm:mt-12 bg-gradient-to-r from-[#A51E29] to-[#A51E29] rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center"
           whileHover={{ scale: 1.02 }}
           transition={{ type: "spring", stiffness: 300, damping: 30 }}
         >
           <h3 className="text-xl sm:text-2xl font-bold mb-2 sm:mb-3">Plumbing Emergency?</h3>
           <p className="text-red-100 mb-4 sm:mb-6 text-sm sm:text-base">We're available 24/7 for urgent repairs and emergencies</p>
           <motion.a
             href="tel:+1-973-862-0606"
             className="inline-flex items-center space-x-2 bg-white text-[#A51E29] px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
             whileHover={{ scale: 1.05 }}
             whileTap={{ scale: 0.95 }}
           >
             <Phone className="h-5 w-5 sm:h-6 sm:w-6" />
             <span>Call Now: (973) 862-0606</span>
           </motion.a>
         </motion.div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 Mount Olive Plumbing, Heating & Air Conditioning. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
  <a href="/privacy-policy" className="hover:text-white transition-colors duration-300">Privacy Policy</a>
  <a href="/terms-of-service" className="hover:text-white transition-colors duration-300">Terms of Service</a>
<a rel="noopener noreferrer" className="hover:text-white transition-colors duration-300">License: #36BI01396600 / #19HC00802000</a>
</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;